export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    const context = this;
    window.clearTimeout(window.timeout);
    window.timeout = window.setTimeout(() => func.apply(context, args), wait);
  };
}
